import { useEffect, useState } from "react";
import { EspecialistaAdminCreate } from "./EspecialistaAdminCreate";
import { useLoaderData, useParams } from "react-router-dom";
import Select from "react-select";

import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import es from 'react-phone-input-2/lang/es.json'

export function EspecialistaAdminNew() {

  function generatePassword(length = 12) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()';
    let password = '';
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      password += characters[randomIndex];
    }
    return password;
  }

  const [isCreatingButton, setIsCreatingButton] = useState(false);
  const [isDeletingButton, setIsDeletingButton] = useState(false);


  // Set default valor for today date
  const todayDate = new Date().toISOString().replace(/T.*/,'').split('-').join('-');

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [telefono, setTelefono] = useState("");
  const [telefonoSecundario, setTelefonoSecundario] = useState("");
  const [direccion, setDireccion] = useState("");
  const [direccionNum, setDireccionNum] = useState("");
  const [direccionPiso, setDireccionPiso] = useState("");
  const [direccionCiudad, setDireccionCiudad] = useState("");
  const [direccionProvincia, setDireccionProvincia] = useState("");
  const [direccionCp, setDireccionCp] = useState("");
  const [dni, setDni] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [especialidad, setEspecialidad] = useState("");
  const [colegiado, setColegiado] = useState("");
  const [estadoUsuario, setEstadoUsuario] = useState('activo');


  // Load Espacialidades Options
  const especialidadOpt = [
    { value: 'medicina', label: 'Medicina' },
    { value: 'psicologia', label: 'Psicología' },
    { value: 'psicologia-hospital', label: 'Psicólogo Hospital' },
    { value: 'nutricion', label: 'Nutrición' },
    { value: 'entrenamiento', label: 'Entrenamiento' },
    { value: 'mindfulness', label: 'Mindfulness' }
  ];

  useEffect(() => {
    const newPassword = generatePassword();
    setPassword(newPassword);
  }, []);


  // Load Especialista and Pacieste Autfill Data
  useEffect(() => {
    const niceUsername = async () => {

      let userMail = email.substring(0, email.indexOf("@"));

      setUsername(userMail);
    };
    // Call the function
    niceUsername();
  }, [email]);

  

  const submitEspecialistaAdmin = async (e) => {
    e.preventDefault();
    setIsCreatingButton(true);
    console.log(
      firstName,
      lastName,
      direccion,
      direccionNum,
      direccionPiso,
      direccionCiudad,
      direccionProvincia,
      direccionCp,
      email,
      telefono,
      telefonoSecundario,
      dni,
      username,
      password,
      especialidad,
      estadoUsuario,
      colegiado
    );
    try {
      await EspecialistaAdminCreate(
        firstName,
        lastName,
        direccion,
        direccionNum,
        direccionPiso,
        direccionCiudad,
        direccionProvincia,
        direccionCp,
        email,
        telefono,
        telefonoSecundario,
        dni,
        username,
        password,
        especialidad,
        estadoUsuario,
        colegiado
      ).then(
        (val) => {
          window.location.replace(
            `../especialistas/${val.id}`
          );
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <div id='content'>
        <form id='formNewElement' onSubmit={submitEspecialistaAdmin}>
        <h3>Crear Especialista</h3>
          <div className='grid--2col'>
            <div className='field'>
              <label htmlFor='firstName'>Nombre</label>
              <div className='control'>
                <input
                  className='input'
                  id='firstName'
                  required
                  type='text'
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                />
              </div>
            </div>
            <div className='field'>
              <label htmlFor='lastName'>Apellidos</label>
              <div className='control'>
                <input
                  className='input'
                  id='lastName'
                  required
                  type='text'
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                />
              </div>
            </div>
          </div>
 
          <div className='grid--2col'>
            <div className='field'>
              <label htmlFor='email'>Email</label>
              <div className='control'>
                <input
                  className='input'
                  id='email'
                  required
                  type='email'
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
            </div>
            <div className='field'>
              <label htmlFor='dni'>DNI</label>
              <div className='control'>
                <input
                  className='input'
                  id='dni'
                  required
                  type='text'
                  value={dni}
                  onChange={(e) => setDni(e.target.value)}
                />
              </div>
            </div>
            
          </div>

          <div className='grid--2col'>
            <div className='field'>
              <label htmlFor='telefono'>Teléfono Móvil</label>
              <div className='control'>
                <PhoneInput
                  inputProps={{
                    className: 'input',
                    name: 'telefono',
                    required: true,
                    id: 'telefono'
                  }}
                  placeholder='+34 658 309 174'
                  localization={es}
                  value={telefono}
                  country={'es'}
                  onChange={(value) => setTelefono( value )}
                />
              </div>
            </div>
            <div className='field'>
              <label htmlFor='telefonoSecundario'>
                Número de teléfono secundario
              </label>
              <div className='control'>
                <PhoneInput
                  inputProps={{
                    className: "input",
                    name: "telefonoSecundario",
                    required: true,
                    id: "telefonoSecundario",
                  }}
                  placeholder='+34 658 309 174'
                  localization={es}
                  value={telefonoSecundario}
                  country={"es"}
                  onChange={(value) => setTelefonoSecundario(value)}
                />
              </div>
            </div>
          </div>

          <div className='grid--2col'>
            <div className='field'>
              <label htmlFor='direccion'>Dirección</label>
              <div className='control'>
                <input
                  className='input'
                  id='direccion'
                  type='text'
                  value={direccion}
                  onChange={(e) => setDireccion(e.target.value)}
                />
              </div>
            </div>
            <div className='field'>
              <label htmlFor='direccionNum'>Número</label>
              <div className='control'>
                <input
                  className='input'
                  id='direccionNum'
                  type='text'
                  value={direccionNum}
                  onChange={(e) => setDireccionNum(e.target.value)}
                />
              </div>
            </div>
            <div className='field'>
              <label htmlFor='direccionPiso'>Piso</label>
              <div className='control'>
                <input
                  className='input'
                  id='direccionPiso'
                  type='text'
                  value={direccionPiso}
                  onChange={(e) => setDireccionPiso(e.target.value)}
                />
              </div>
            </div>

            <div className='field'>
              <label htmlFor='direccionCiudad'>Población</label>
              <div className='control'>
                <input
                  className='input'
                  id='direccionCiudad'
                  type='text'
                  value={direccionCiudad}
                  onChange={(e) => setDireccionCiudad(e.target.value)}
                />
              </div>
            </div>
            <div className='field'>
              <label htmlFor='direccionProvincia'>Provincia</label>
              <div className='control'>
                <input
                  className='input'
                  id='direccionProvincia'
                  type='text'
                  value={direccionProvincia}
                  onChange={(e) => setDireccionProvincia(e.target.value)}
                />
              </div>
            </div>
            <div className='field'>
              <label htmlFor='direccionCp'>Código postal</label>
              <div className='control'>
                <input
                  className='input'
                  id='direccionCp'
                  type='text'
                  value={direccionCp}
                  onChange={(e) => setDireccionCp(e.target.value)}
                />
              </div>
            </div>
          </div>

          <div className='grid--2col'>
            <div className='field'>
              <label htmlFor='username'>Nombre de usuario</label>
              <div className='control'>
                <input
                  className='input'
                  id='username'
                  required
                  readOnly
                  type='text'
                  value={username}
                  disabled
                />
              </div>
            </div>
            <div className='field'>
              <label htmlFor='password'>Contraseña</label>
              <div className='control'>
                <input
                  className='input'
                  id='password'
                  required
                  type='text'
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
            </div>
          </div>

          <div className='grid--2col'>
            <div className='field'>
              <label htmlFor='especialidad'>Especialidad</label>
              <div className='control'>
                  <Select
                          isMulti
                          id='especialidad'
                          name='especialidad'
                          options={especialidadOpt}
                          className='basic-multi-select'
                          classNamePrefix='select'
                          placeholder='Seleccionar especialidad'
                          onChange={setEspecialidad}
                        />
                        


                {/* <div className='select'>
                  <select
                    className='select'
                    id='especialidad'
                    required
                    name='especialidad'
                    defaultValue=''
                    onChange={(e) => setEspecialidad(e.target.value)}
                  >
                    <option disabled value=''>-- Selecciona una opción --</option>
                    <option value='medicina'>Medicina</option>
                    <option value='psicologia'>Psicología</option>
                    <option value='psicologia-hospital'>Psicólogo Hospital</option>
                    <option value='nutricion'>Nutrición</option>
                    <option value='entrenamiento'>Entrenamiento</option>
                    <option value='mindfulness'>Mindfulness</option>
                  </select>
                </div> */}
              </div>
            </div>
            <div className='field'>
              <label htmlFor='colegiado'>Número de Colegiado</label>
              <div className='control'>
                <input
                  className='input'
                  id='colegiado'
                  type='text'
                  value={colegiado}
                  onChange={(e) => setColegiado(e.target.value)}
                />
              </div>
            </div>
          </div>

          <div className='grid--2col'>
            <div className="field">
              <label htmlFor="estadoUsuario">Estado del usuario</label>
              <div className="control">
                <div className="select">
                  <select
                    className="select"
                    id="estadoUsuario"
                    required
                    name="estadoUsuario"
                    value={estadoUsuario}
                    onChange={(e) => setEstadoUsuario(e.target.value)}
                  >
                    <option disabled value="">-- Selecciona una opción --</option>
                    <option value="activo">Activo</option>
                    <option value="inactivo">Inactivo</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

        </form>
      </div>
      <div id='actions'>
        <button 
        className='button is-link' 
        form='formNewElement' 
        type='submit'
        disabled={ isCreatingButton}
        >
          { isCreatingButton ? <div className="spinner"></div> : 'Guardar'}
        </button>
      </div>
    </>
  );
}
